import { RiskSequence } from '../../../../investment-profile/components/RiskSequence';
import { exitToFinancialProfile } from '../../../../investment-profile/navigation';

export default function RiskProfilePage() {
    return (
        <RiskSequence
            onBack={exitToFinancialProfile}
            onComplete={exitToFinancialProfile}
        />
    );
}
